export const basicCircleConfig = {
  type: 'shape',
  shape_type: 'ellipse',
  x: '50%',
  y: '50%',
  width: '25 vmin',
  height: '25 vmin',
  path: 'M 50 0 C 77.61 0 100 22.39 100 50 C 100 77.61 77.61 100 50 100 C 22.39 100 0 77.61 0 50 C 0 22.39 22.39 0 50 0 Z',
  aspect_ratio: '1',
  x_anchor: '50%',
  y_anchor: '50%',
  y_scale: '-100%',
  fill_color: '#575757',
  opacity: '100%',
};

export const basicRectangleConfig = {
  type: 'shape',
  shape_type: 'rectangle',
  x: '50%',
  y: '50%',
  width: '50%',
  height: '50%',
  path: 'M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z',
  x_anchor: '50%',
  y_anchor: '50%',
  y_scale: '-100%',
  fill_color: '#575757',
  opacity: '100%',
  border_radius: '0 vmin',
};

export const basicRoundedRectangleConfig = {
  type: 'shape',
  shape_type: 'rectangle',
  x: '50%',
  y: '50%',
  width: '50%',
  height: '50%',
  path: 'M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z',
  x_anchor: '50%',
  y_anchor: '50%',
  y_scale: '-100%',
  fill_color: '#575757',
  opacity: '100%',
  border_radius: '10 vmin',
};
